
export const portfolioData = [
    {
        "cover": require("../../portfolio/23/TTC.PNG"),
        "title": "Teddy's Tallow Chips",
        "description": "Website for some of the best tallow chips.",
        "stack": "MERN",
        "url": "https://teddystallowchips.com",
        "src": ""
    },
]
